export const brandsPerPageDefault = 20;

export const searchFilterDebounceMs = 250;
